import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  notification,
  Upload,
  InputNumber,
} from "antd";
import {
  PlusOutlined,
  DownloadOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import CurrencyInput from "react-currency-input";
import ScreenOptions from "../../util/Extensions/Screens";
import config from "../../util/ApiforContext";
import { odata } from "../Filters/Helper/index";
const { TextArea } = Input;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 12,
    },
  },
};

const StockAddForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: true,
  });

  const [purchasePriceIncTaxes, setPurchasePriceIncTaxes] = useState(0);
  const [sellingPriceIncTaxes, setSellingPriceIncTaxes] = useState(0);
  const [purchasePriceExcTaxes, setPurchasePriceExcTaxes] = useState(0);
  const [sellingPriceExcTaxes, setSellingPriceExcTaxes] = useState(0);
  const [vatRate, setVatRate] = useState(20);
  const [fileList, setFileList] = useState([]);
  const [projectSelect, setProjectSelect] = useState({
    data: [],
    loading: false,
  });

  const [materialSelect, setMaterialSelect] = useState({
    data: [],
    loading: true,
  });

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
    getCurrencies();
    RequestHandler.get(
      `/TransactionProjectType?$select=id,projectCode,name`
    ).then((res) => {
      setProjectSelect({
        data: res.value,
        loading: false,
      });
    });
  }, [props.data]);

  useEffect(() => {
    RequestHandler.get(`/Stock/GetEntityCode`).then((res) => {
      if (res) {
        form.setFieldsValue({ stockCode: res });
      }
    });
  }, []);

  const onSuccess = () => {
    form.resetFields();
    setFileList([]);

    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    if (values.vatRate == undefined) {
      values.vatRate = 20;
    }

    RequestHandler.post(`/Stock`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const getCurrencies = () => {
    setCurrencySelect({
      ...currencySelect,
      loading: true,
    });
    RequestHandler.get(`/Currency/GetFilterCurrency`).then((response) => {
      setCurrencySelect({
        data: response,
        loading: false,
      });
    });
  };

  const downloadExcelTemplate = () => {
    window.open(
      `${config.apiUrl}/Stock/DownloadExcel?t=${RequestHandler.getToken()}`
    );
  };

  const downloadImportResult = (fileName) => {
    window.open(
      `${
        config.apiUrl
      }/Stock/DownloadImportResult?t=${RequestHandler.getToken()}&fileName=${fileName}`
    );
  };

  const uploadExcelProps = {
    name: "excel",
    action: `${config.apiUrl}/Stock/ImportExcel`,
    headers: {
      Authorization: "bearer " + RequestHandler.getToken(),
      ScreenOption: ScreenOptions.screen,
    },
    accept: ".xlsx",
    maxCount: 1,
    onChange(info) {
      setFileList(info.fileList);
      const { response, status } = info.file;

      if (status !== "error" && status !== "done") return;
      if (!response) return;

      const notificationType = response.success ? "success" : "error";

      notification[notificationType]({
        message: response.message,
        duration: 3,
      });
      if (!response.success) {
        downloadImportResult(info.file.response.data);
      }
      onSuccess();
    },
  };

  const onProjectSearch = (value) => {
    if (value.length >= 2) {
      setProjectSelect({ data: [], loading: true });

      RequestHandler.get(
        `/TransactionProjectType?$select=id,projectCode,name&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("projectCode", value)})  and Name ne 'Diğer'`
      ).then((res) => {
        setProjectSelect({ data: res.value, loading: false });
      });
    } else {
      setProjectSelect({ data: [], loading: false });
    }
  };

  const onMaterialSeach = (value) => {
    if (value.length >= 2) {
      setMaterialSelect({ data: [], loading: true });

      RequestHandler.get(
        `/MaterialCategory?$select=id,code,name,totalName&$filter=(${odata.contains(
          "totalName",
          value
        )} or ${odata.contains("code", value)}) and Name ne 'Diğer'`
      ).then((res) => {
        setMaterialSelect({ data: res.value, loading: false });
      });
    } else {
      setMaterialSelect({ data: [], loading: false });
    }
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name="stockAdd"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item
            label="Ürün Adı"
            name="name"
            rules={[
              { required: true, message: "Lütfen Ürün adını boş bırakmayın." },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Stok Kodu"
            name="stockCode"
            rules={[
              {
                required: true,
                message: "Lütfen Stok Kodu'nu boş bırakmayın.",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Güncel Stok"
            name="count"
            rules={[
              {
                required: true,
                message: "Lütfen Güncel Stok giriniz.",
              },
            ]}
          >
            <InputNumber
              className="ant-input"
              style={{ width: "100%" }}
              decimalSeparator=","
              thousandSeparator="."
              precision={2}
              placeholder="0,00"
            />
            {/* <CurrencyInput
              className="ant-input"
              style={{ width: "100%" }}
              decimalSeparator=","
              thousandSeparator="."
              onChange={(value, name) => {
                form.setFieldsValue({
                  count: name,
                });
              }}
            /> */}
          </Form.Item>

          <Form.Item
            label="Stok Birimi"
            name="unit"
            rules={[{ required: true, message: "Lütfen Stok Birimi giriniz." }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="currencyCode"
            label="Para Birimi"
            rules={[
              { required: true, message: "Lütfen Para Birimi seçiniz.." },
            ]}
          >
            <Select
              allowClear
              showSearch
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={currencySelect.loading}
            >
              {currencySelect.data.map(({ text, value }) => (
                <Select.Option key={text} value={text}>
                  {value}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="transactionProjectTypeId"
            label="Ana Depo :"
            rules={[{ required: true, message: "Lütfen Ana Depo seçiniz." }]}
          >
            <Select
              allowClear
              showSearch
              placeholder="En az 2 harf giriniz.."
              onSearch={onProjectSearch}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                option.code
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={projectSelect.loading}
            >
              {projectSelect.data.map((item) => (
                <Select.Option
                  key={item.id}
                  value={item.id}
                  code={item.projectCode}
                >
                  {item.name + " (" + item.projectCode + ")"}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="materialCategoryId" label="Kategori :">
            <Select
              allowClear
              showSearch
              placeholder="En az 2 harf giriniz.."
              onSearch={onMaterialSeach}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                option.code
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={materialSelect.loading}
            >
              {materialSelect.data.map((item) => (
                <Select.Option
                  key={item.id}
                  value={item.id}
                  code={item.firmBranchNumber}
                >
                  {item.totalName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          {/* <Form.Item label="Raf No" name="shelfNo">
            <Input />
          </Form.Item>
          <Form.Item label="Palet No" name="palletNo">
            <Input />
          </Form.Item>
          <Form.Item label="Kap No" name="containerNo">
            <Input />
          </Form.Item>
          <Form.Item label="İstasyon No" name="stationNo">
            <Input />
          </Form.Item> */}

          <Form.Item label="KDV Oranı" name="vatRate">
            <Select
              defaultValue={20}
              allowClear
              showSearch
              onChange={(value) => {
                form.setFieldsValue({
                  purchasePriceIncTaxes: Math.abs(
                    (purchasePriceExcTaxes * value) / 100 +
                      Math.abs(purchasePriceExcTaxes)
                  ),
                  sellingPriceIncTaxes: Math.abs(
                    (sellingPriceExcTaxes * value) / 100 +
                      Math.abs(sellingPriceExcTaxes)
                  ),
                });
                setVatRate(value);
              }}
            >
              <Select.Option key={1} value={1}>
                %1
              </Select.Option>
              <Select.Option key={10} value={10}>
                %10
              </Select.Option>
              <Select.Option key={20} value={20}>
                %20
              </Select.Option>
            </Select>
          </Form.Item>

          <Form.Item label="Tevkifat (%)" name="taxRate">
            <CurrencyInput
              className="ant-input"
              style={{ width: "100%" }}
              decimalSeparator=","
              thousandSeparator="."
              onChange={(value, name) => {
                form.setFieldsValue({
                  taxRate: name,
                });
              }}
            />
          </Form.Item>

          <Form.Item label="Vergisiz Alış Fiyatı" name="purchasePriceExcTaxes">
            <CurrencyInput
              className="ant-input"
              style={{ width: "100%" }}
              decimalSeparator=","
              thousandSeparator="."
              onChange={(value, name) => {
                form.setFieldsValue({
                  purchasePriceIncTaxes: Math.abs(
                    (name * vatRate) / 100 + name
                  ),
                  purchasePriceExcTaxes: name,
                });
                setPurchasePriceExcTaxes(
                  parseFloat(name.toString()).toFixed(2)
                );
              }}
            />
          </Form.Item>
          <Form.Item label="Vergisiz Satış Fiyatı" name="sellingPriceExcTaxes">
            <CurrencyInput
              className="ant-input"
              style={{ width: "100%" }}
              decimalSeparator=","
              thousandSeparator="."
              onChange={(value, name) => {
                form.setFieldsValue({
                  sellingPriceIncTaxes: Math.abs((name * vatRate) / 100 + name),
                  sellingPriceExcTaxes: name,
                });
                setSellingPriceExcTaxes(parseFloat(name.toString()).toFixed(2));
              }}
            />
          </Form.Item>
          <Form.Item
            label="Vergiler Dahil Alış Fiyatı"
            name="purchasePriceIncTaxes"
          >
            <CurrencyInput
              className="ant-input"
              style={{ width: "100%" }}
              decimalSeparator=","
              thousandSeparator="."
              onChange={(value, name) => {
                form.setFieldsValue({
                  purchasePriceExcTaxes: Math.abs(
                    (name / (100 + vatRate)) * 100
                  ),
                  purchasePriceIncTaxes: name,
                });
                setPurchasePriceExcTaxes(
                  Math.abs((name / (100 + vatRate)) * 100)
                );
                setPurchasePriceIncTaxes(
                  parseFloat(name.toString()).toFixed(2)
                );
              }}
            />
          </Form.Item>
          <Form.Item
            label="Vergiler Dahil Satış Fiyatı"
            name="sellingPriceIncTaxes"
          >
            <CurrencyInput
              className="ant-input"
              style={{ width: "100%" }}
              decimalSeparator=","
              thousandSeparator="."
              onChange={(value, name) => {
                form.setFieldsValue({
                  sellingPriceExcTaxes: Math.abs(
                    (name / (100 + vatRate)) * 100
                  ),
                  sellingPriceIncTaxes: name,
                });
                setSellingPriceExcTaxes(
                  Math.abs((name / (100 + vatRate)) * 100)
                );
                setSellingPriceIncTaxes(parseFloat(name.toString()).toFixed(2));
              }}
            />
          </Form.Item>

          <Form.Item label="Açıklama" name="description">
            <TextArea rows={4} />
          </Form.Item>

          <Row justify="space-between">
            <Col>
              <Button
                icon={<DownloadOutlined />}
                onClick={(() => setLoading(true), downloadExcelTemplate)}
                loading={loading}
              >
                Excel Şablonu İndir
              </Button>
              <Upload {...uploadExcelProps} fileList={fileList}>
                <Button icon={<UploadOutlined />}>Excel ile Ekle</Button>
              </Upload>
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Ekle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default StockAddForm;
